import { groupBy } from 'lodash';
import { EventMarketItemType } from 'src_common/common/websocket2/modelsApi/EventMarkets';
import { getDisplayTemplatePrefix, GroupedEventMarkets, UNGROUPED_TEMPLATES } from './shared';

const GROUPS: Record<string, string> = {
    'first-goalscorer': 'goalscorer',
    'anytime-goalscorer': 'goalscorer',
    'hattrick-goalscorer': 'goalscorer',
};

export const groupMarketsClassic = (markets: Array<EventMarketItemType>): GroupedEventMarkets => {
    return groupBy(markets, (market) => {
        const marketGrouping = market.tags['group-template'];
        const templateId = market.templateId;
        const marketDisplayTemplate = getDisplayTemplatePrefix(market);
        const groupTemplate = GROUPS[templateId] ?? null;

        if (groupTemplate !== null || marketGrouping === 'yes') {
            if (groupTemplate !== null) {
                return groupTemplate;
            }
            return marketDisplayTemplate + templateId;
        }

        if (UNGROUPED_TEMPLATES.includes(templateId)) {
            return `${marketDisplayTemplate + templateId}-ungrouped-${market.id}`;
        }

        return `${marketDisplayTemplate}${market.id}`;
    });
};
